import { CartItem } from '../types/cart'
import { Product } from '../types/product'

// Augment Window so transport files can reference gtag/fbq/dataLayer without any
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
    fbq: (...args: unknown[]) => void
    gtag: (...args: unknown[]) => void
    __hhAnalyticsDebug?: {
      dispatched: number
      queued: number
      dropped: number
      failed: number
    }
  }
}

export type DomainEvent =
  | 'page_view'
  | 'view_item'
  | 'view_item_list'
  | 'search'
  | 'add_to_cart'
  | 'remove_from_cart'
  | 'view_cart'
  | 'begin_checkout'
  | 'add_payment_info'
  | 'purchase'
  | 'add_to_wishlist'
  | 'generate_lead'
  | 'sign_up'
  | 'login'

export type ConsentValue = 'granted' | 'denied'

export interface ConsentSnapshot {
  ad_storage: ConsentValue
  analytics_storage: ConsentValue
  ad_user_data: ConsentValue
  ad_personalization: ConsentValue
}

export interface EventItem {
  id: string
  name: string
  category?: string
  variant?: string
  price: number
  quantity: number
  discount?: number
}

export interface EventPayload {
  event_id?: string
  items?: EventItem[]
  value?: number
  currency?: string
  transaction_id?: string
  search_term?: string
  method?: string
  payment_type?: string
  list_id?: string
  list_name?: string
}

export interface AnalyticsEvent {
  name: DomainEvent
  event_id: string
  event_time: number
  event_source_url: string
  payload: EventPayload
  consent: ConsentSnapshot
  fbp?: string
  fbc?: string
  ga_client_id?: string
  // Identity stamped from the analytics identity registry at dispatch time.
  // external_id is always populated (falls back to per-device anonymous UUID).
  // email/phone are raw values; the backend hashes (SHA-256) before egress to
  // vendor endpoints (Meta CAPI / GA4 MP).
  external_id?: string
  email?: string
  phone?: string
}

export function isCriticalEvent(name: DomainEvent): boolean {
  return name === 'purchase' || name === 'begin_checkout' || name === 'generate_lead' || name === 'sign_up'
}

// These are used only for type-narrowing in mappers — re-exported from types
export type { Product, CartItem }
